export const EmptyDocIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M14.0001 12H26.0001M14.0001 18H26.0001M14.0001 24H20.0001M10.9997 4H29C31.2092 4 33.0001 5.79091 33 8.00008L32.9996 32.0001C32.9995 34.2092 31.2087 36 28.9996 36L10.9995 35.9999C8.79035 35.9999 6.9995 34.209 6.99951 31.9999L6.99967 7.99998C6.99968 5.79085 8.79054 4 10.9997 4Z"
        stroke="black"
        strokeOpacity="0.15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
